import { create } from "zustand";

export enum CookieConsentStatus {
  Accepted = "accepted",
  Declined = "declined",
  Undecided = "undecided",
}

type UseCookieConsentStore = {
  status: CookieConsentStatus;
  accept: () => void;
  reject: () => void;
  init: () => void;
};

const useCookieConsentStore = create<UseCookieConsentStore>((set) => ({
  status: CookieConsentStatus.Undecided,
  accept: () => {
    set({ status: CookieConsentStatus.Accepted });
    localStorage.setItem("CookieConsent", CookieConsentStatus.Accepted);
  },
  reject: () => {
    set({ status: CookieConsentStatus.Declined });
    localStorage.setItem("CookieConsent", CookieConsentStatus.Declined);
  },
  init: () => {
    const storedConsent = localStorage.getItem("CookieConsent");
    if (storedConsent === CookieConsentStatus.Accepted) {
      set({ status: CookieConsentStatus.Accepted });
    } else if (storedConsent === CookieConsentStatus.Declined) {
      set({ status: CookieConsentStatus.Declined });
    }
  },
}));

export const useCookieConsentStatus = () =>
  useCookieConsentStore((state) => state.status);
export const useAcceptCookieConsent = () =>
  useCookieConsentStore((state) => state.accept);
export const useRejectCookieConsent = () =>
  useCookieConsentStore((state) => state.reject);
export const initCookieConsentStore = () =>
  useCookieConsentStore.getState().init();
